import { Link } from 'react-router-dom';
import { FaBuilding } from 'react-icons/fa';
import UniversalTag from '../../custom-components/UniversalTag';
import './InstitutionLink.scss';

interface InstitutionLinkProps {
  id: string;
  name?: string;
  access?: string;
  state?: string;
}

export function InstitutionLink({ id, name, access, state }: InstitutionLinkProps) {
  if (!name) return null;

  const displayName = state ? `${name}, ${state}` : name;

  return (
    <div className="institution-link">
      <FaBuilding className="institution-link__icon" />
      <Link className="institution-link__name" to={`/directory/institutions/${id}`}>
        {displayName}
      </Link>
      {access && <UniversalTag category={access} />}
    </div>
  );
}
